export function selectHelper( $select , step = 1) {
    const $label = $select.closest(".form-group").find("label");

    switch (step) {
        case 1:

            $select.empty();
            break;   

        case 2:

            $select.prop("disabled", true);
            $select.append('<option value="">Patientez ...</option>');
            // $label.html('Activité <span class=" fa fa-spin fa-spinner"></span>');
            const originalText = $label.text();
            $label.html(`${originalText} <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>`);
            
            break;
        case 3:

            $select.prop("disabled", false);
            $select.empty();
            $select.append('<option value="">Séléctionnez</option>');

            break;
        case 4:            
            $label.text($label.text());    
        default:
            break;
    }
}